import type { LegalDocumentSection } from './legal-document';

export const PRIVACY_POLICY_VERSION = '1.0';
export const PRIVACY_POLICY_EFFECTIVE_DATE = '2026-09-02';
export const PRIVACY_POLICY_EFFECTIVE_DATE_LABEL = '2 de setembro de 2026';

export const PRIVACY_POLICY_OWNER_NAME = 'Carlos Silveira';
export const PRIVACY_POLICY_OWNER_ADDRESS =
  'Ponta do Topo, 9875-115 Calheta, Açores, Portugal';
export const PRIVACY_POLICY_OWNER_EMAIL = 'carlos.dt.cd@gmail.com';

export const privacyPolicySections: ReadonlyArray<LegalDocumentSection> = [
  {
    id: 'resumo',
    title: 'Resumo',
    blocks: [
      {
        paragraphs: [
          'A BelaHora é um software de marcações para salões e negócios de serviços, operado por Carlos Silveira. Esta política explica que Dados Pessoais recolhemos quando visita o nosso site ou utiliza a aplicação, com que finalidade os tratamos, com quem os partilhamos e que direitos tem sobre eles.',
          'Aplica-se a esta Aplicação enquanto a BelaHora atua como Responsável pelo Tratamento. Quando um salão nosso cliente insere na aplicação dados dos seus próprios clientes, é esse salão o Responsável pelo Tratamento e a BelaHora é apenas Subcontratante: essa relação é regulada pelo Acordo de Tratamento de Dados disponível em /dpa.',
        ],
      },
      {
        heading: 'Dados que recolhemos automaticamente',
        paragraphs: [
          'Recolhemos alguns Dados de Utilização automaticamente quando visita a BelaHora, tal como acontece com qualquer serviço alojado na Internet. Estes dados são tratados pelos nossos fornecedores de alojamento e infraestrutura para servir as páginas, manter o serviço a funcionar e detetar abusos.',
        ],
        bullets: [
          'Dados de Utilização, incluindo endereço IP, data e hora do pedido, páginas visitadas e características do navegador e do sistema operativo.',
          'Registos técnicos do sistema gerados pela aplicação e pelos servidores.',
        ],
      },
      {
        heading: 'Dados que nos fornece',
        paragraphs: [
          'Recolhemos os dados que nos comunica diretamente, por exemplo ao pedir uma auditoria através do formulário do site ou ao criar e utilizar uma conta na aplicação.',
        ],
        bullets: [
          'Nome, nome do negócio, telefone ou WhatsApp, endereço de correio eletrónico, ilha e identificador de Instagram.',
          'Dados de conta e de perfil do negócio necessários para utilizar a aplicação.',
        ],
      },
    ],
  },
  {
    id: 'proprietario-e-responsavel',
    title: 'Proprietário e Responsável pelo Tratamento',
    blocks: [
      {
        paragraphs: [
          `${PRIVACY_POLICY_OWNER_NAME}, ${PRIVACY_POLICY_OWNER_ADDRESS}.`,
          `E-mail de contacto do Proprietário: ${PRIVACY_POLICY_OWNER_EMAIL}.`,
        ],
      },
    ],
  },
  {
    id: 'tipos-de-dados',
    title: 'Tipos de Dados recolhidos',
    blocks: [
      {
        heading: 'Dados fornecidos pelo Utilizador',
        bullets: [
          'Nome do responsável pelo negócio.',
          'Nome da empresa ou do salão.',
          'Número de telefone ou WhatsApp.',
          'Endereço de correio eletrónico.',
          'Ilha ou localidade do negócio.',
          'Identificador de Instagram, quando fornecido.',
          'Conteúdo livre das mensagens que nos envia e informação de contexto do pedido de auditoria, como as estimativas introduzidas na calculadora do site.',
          'Credenciais e dados de conta, incluindo endereço de correio eletrónico e palavra-passe cifrada, quando cria uma conta.',
          'Dados do perfil do negócio, como morada, contactos públicos, fuso horário e descrição, quando configura a aplicação.',
        ],
      },
      {
        heading: 'Dados recolhidos automaticamente',
        bullets: [
          'Dados de Utilização e registos do sistema, conforme descrito no resumo.',
          'Identificadores técnicos de sessão necessários para o manter autenticado na aplicação.',
        ],
      },
      {
        heading: 'Dados tratados por conta dos nossos clientes',
        paragraphs: [
          'A aplicação permite que os salões nossos clientes registem dados dos seus próprios clientes finais, como nome, contactos, histórico de marcações e data de nascimento quando fornecida. Relativamente a esses dados a BelaHora atua como Subcontratante e trata-os apenas segundo as instruções do salão. As condições aplicáveis constam do Acordo de Tratamento de Dados disponível em /dpa.',
        ],
      },
      {
        paragraphs: [
          'Salvo indicação em contrário, os Dados assinalados como obrigatórios são necessários para prestar o Serviço solicitado, podendo a sua não disponibilização impedir a BelaHora de responder ao pedido ou de disponibilizar a aplicação. Os campos indicados como opcionais podem ser deixados em branco sem afetar o funcionamento do Serviço.',
          'O Utilizador é responsável por quaisquer Dados Pessoais de terceiros que obtenha, publique ou partilhe através desta Aplicação, devendo assegurar que dispõe de fundamento de licitude para o fazer.',
          'Esta Aplicação não recolhe intencionalmente categorias especiais de dados pessoais e não se destina a menores de 16 anos.',
        ],
      },
    ],
  },
  {
    id: 'modo-e-local',
    title: 'Modo e local de tratamento dos Dados',
    blocks: [
      {
        heading: 'Métodos de tratamento',
        paragraphs: [
          'O Proprietário adota medidas técnicas e organizativas adequadas para impedir o acesso não autorizado, a divulgação, a alteração ou a destruição não autorizada dos Dados, incluindo cifragem em trânsito, controlo de acessos e limitação do acesso ao pessoal que dele necessite.',
          'O tratamento é realizado através de meios informáticos, segundo procedimentos e finalidades estritamente relacionados com os fins indicados nesta política. Para além do Proprietário, os Dados podem ser acessíveis a fornecedores externos nomeados como Subcontratantes, tais como fornecedores de alojamento, de infraestrutura e de envio de mensagens. A lista atualizada destes fornecedores pode ser solicitada ao Proprietário a qualquer momento.',
        ],
      },
      {
        heading: 'Local',
        paragraphs: [
          'Os Dados são tratados nas instalações onde o Proprietário exerce a sua atividade, em Portugal, e nas infraestruturas dos fornecedores identificados na secção de informações detalhadas.',
          'O envio de mensagens SMS é efetuado, por defeito, através de um fornecedor estabelecido em Portugal, não implicando transferência de Dados para fora do Espaço Económico Europeu.',
          'Os fornecedores de alojamento, de correio eletrónico e o fornecedor de SMS utilizado em recurso estão sediados nos Estados Unidos da América, pelo que o tratamento pode implicar a transferência de Dados para fora do Espaço Económico Europeu. Essas transferências assentam nas Cláusulas Contratuais-Tipo aprovadas pela Comissão Europeia ou noutro mecanismo de transferência adequado previsto no Capítulo V do RGPD, incluindo, quando aplicável, a decisão de adequação relativa ao Enquadramento de Privacidade de Dados UE-EUA.',
        ],
      },
      {
        heading: 'Período de conservação',
        paragraphs: [
          'Os Dados Pessoais são tratados e conservados durante o tempo necessário para a finalidade que motivou a sua recolha, podendo ser conservados por mais tempo em virtude de obrigações legais aplicáveis ou com base no consentimento do Utilizador.',
        ],
        bullets: [
          'Pedidos de auditoria e mensagens de contacto: até 24 meses após o último contacto, salvo oposição anterior do Utilizador.',
          'Dados de conta e de perfil do negócio: durante a vigência da conta e até 30 dias após o seu encerramento.',
          'Cópias de segurança: até 90 dias, findos os quais são sobrescritas no ciclo normal de retenção.',
          'Registos técnicos do sistema: até 12 meses.',
          'Documentos de faturação e contabilísticos: pelo prazo exigido pela legislação fiscal portuguesa aplicável.',
        ],
      },
    ],
  },
  {
    id: 'finalidades',
    title: 'Finalidades do tratamento',
    blocks: [
      {
        paragraphs: [
          'Os Dados relativos ao Utilizador são recolhidos para permitir que o Proprietário preste o seu Serviço, cumpra as suas obrigações legais, responda a pedidos, proteja os seus direitos e interesses ou os de terceiros, detete atividade fraudulenta, bem como para as seguintes finalidades:',
        ],
        bullets: [
          'Contactar o Utilizador e responder a pedidos de auditoria, orçamento ou informação.',
          'Envio de mensagens SMS e de correio eletrónico relacionadas com marcações e com o Serviço.',
          'Infraestrutura de backend e alojamento da Aplicação.',
          'Criação e gestão de contas e prestação das funcionalidades da Aplicação.',
          'Segurança, prevenção de abuso e manutenção técnica.',
          'Cumprimento de obrigações legais, contabilísticas e fiscais.',
        ],
      },
    ],
  },
  {
    id: 'detalhes-tratamento',
    title: 'Informações detalhadas sobre o tratamento de Dados Pessoais',
    blocks: [
      {
        heading: 'Formulário de contacto e pedido de auditoria',
        paragraphs: [
          'Ao preencher o formulário disponível no site com os seus dados, o Utilizador autoriza a BelaHora a utilizá-los para responder ao seu pedido, incluindo o envio da auditoria solicitada e o contacto de seguimento.',
          'Dados Pessoais tratados: nome, nome da empresa, número de telefone ou WhatsApp, endereço de correio eletrónico, ilha, identificador de Instagram e informação de contexto do pedido.',
          'Fundamento jurídico: consentimento do Utilizador e diligências pré-contratuais a seu pedido.',
        ],
      },
      {
        heading: 'Conta e utilização da Aplicação',
        paragraphs: [
          'Os Dados de conta e de perfil do negócio são tratados para autenticar o Utilizador, disponibilizar as funcionalidades contratadas e prestar suporte.',
          'Dados Pessoais tratados: nome, endereço de correio eletrónico, palavra-passe cifrada, dados do negócio e Dados de Utilização.',
          'Fundamento jurídico: execução do contrato celebrado com o Utilizador.',
        ],
      },
      {
        heading: 'Infraestrutura de backend e alojamento',
        paragraphs: [
          'Este tipo de serviço aloja os Dados e ficheiros que permitem o funcionamento e a distribuição desta Aplicação. Alguns destes serviços operam através de servidores geograficamente distribuídos, o que pode dificultar a determinação da localização exata de armazenamento.',
        ],
        bullets: [
          'Vercel — alojamento e distribuição da aplicação, prestado por Vercel Inc. (EUA). Dados tratados: Dados de Utilização e registos técnicos. Política de privacidade: https://vercel.com/legal/privacy-policy',
          'Railway — alojamento do backend e da base de dados, prestado por Railway Corp. (EUA). Dados tratados: os Dados Pessoais armazenados pela Aplicação. Política de privacidade: https://railway.com/legal/privacy',
        ],
      },
      {
        heading: 'Envio de mensagens SMS',
        paragraphs: [
          'Este tipo de serviço permite comunicar com o Utilizador e, quando o cliente ativa essa funcionalidade, com os clientes finais do salão, nomeadamente através do envio de SMS de confirmação, lembrete, alteração ou cancelamento de marcações.',
          'O envio é encaminhado, por defeito, para o fornecedor estabelecido em Portugal. O fornecedor sediado nos Estados Unidos é utilizado apenas em recurso, quando o primeiro não esteja configurado ou o envio falhe.',
        ],
        bullets: [
          'Closum — fornecedor principal de envio de SMS, prestado por Drible, NIPC 513543244, Vila Nova de Famalicão (Portugal). Dados tratados: número de telefone, conteúdo da mensagem e metadados de entrega. Política de privacidade: https://www.closum.com/pt/politica-de-privacidade',
          'Twilio — fornecedor de recurso para envio de SMS, prestado por Twilio, Inc. (EUA). Dados tratados: número de telefone, conteúdo da mensagem e metadados de entrega. Política de privacidade: https://www.twilio.com/legal/privacy',
        ],
      },
      {
        heading: 'Envio de correio eletrónico',
        paragraphs: [
          'As mensagens de correio eletrónico enviadas pela Aplicação, designadamente confirmações, lembretes, alterações e cancelamentos de marcações, comunicações de aniversário e mensagens relacionadas com o acesso à conta, são entregues através de um serviço de correio eletrónico externo.',
        ],
        bullets: [
          'Namecheap Private Email — serviço de correio eletrónico, prestado por Namecheap, Inc. (EUA). Dados tratados: endereço de correio eletrónico do destinatário, conteúdo da mensagem e metadados de entrega. Política de privacidade: https://www.namecheap.com/legal/general/privacy-policy/',
        ],
      },
    ],
  },
  {
    id: 'cookies',
    title: 'Cookies e Rastreadores',
    blocks: [
      {
        paragraphs: [
          'Esta Aplicação utiliza exclusivamente cookies e armazenamento local estritamente necessários ao seu funcionamento, nomeadamente para manter a sessão do Utilizador autenticado e guardar preferências de interface.',
          'Não utilizamos cookies de análise estatística, de perfilagem ou de publicidade, nem partilhamos dados de navegação com redes publicitárias. Por esse motivo, e nos termos do artigo 5.º da Lei n.º 41/2004, não é apresentado um pedido de consentimento para cookies, uma vez que os cookies utilizados são indispensáveis para prestar o serviço expressamente solicitado pelo Utilizador.',
          'O Utilizador pode, a qualquer momento, eliminar ou bloquear cookies nas definições do seu navegador, tendo presente que o bloqueio dos cookies de sessão impede a autenticação na Aplicação.',
        ],
      },
    ],
  },
  {
    id: 'utilizadores-ue',
    title: 'Informação adicional para o Utilizador na União Europeia',
    blocks: [
      {
        paragraphs: [
          'Esta secção aplica-se a qualquer Utilizador da União Europeia, nos termos do Regulamento Geral sobre a Proteção de Dados. Para estes Utilizadores, esta secção prevalece sobre qualquer informação divergente ou incompatível constante do restante documento.',
        ],
      },
      {
        heading: 'Fundamento jurídico do tratamento',
        paragraphs: [
          'O Proprietário pode tratar Dados Pessoais relativos ao Utilizador caso se aplique uma das seguintes situações:',
        ],
        bullets: [
          'O Utilizador prestou o seu consentimento para uma ou mais finalidades específicas.',
          'O tratamento é necessário para a execução de um contrato com o Utilizador ou para diligências pré-contratuais a seu pedido.',
          'O tratamento é necessário para o cumprimento de uma obrigação legal a que o Proprietário esteja sujeito.',
          'O tratamento é necessário para efeitos dos interesses legítimos prosseguidos pelo Proprietário ou por terceiros, designadamente a segurança do serviço e a prevenção de abuso.',
        ],
      },
      {
        heading: 'Direitos do Utilizador',
        paragraphs: [
          'O Utilizador pode exercer, na medida permitida por lei, os seguintes direitos relativamente aos Dados tratados pelo Proprietário:',
        ],
        bullets: [
          'Retirar o consentimento a qualquer momento, quando o tratamento se baseie no consentimento previamente prestado, sem prejuízo da licitude do tratamento anterior.',
          'Opor-se ao tratamento dos seus Dados quando este assente num fundamento jurídico distinto do consentimento.',
          'Aceder aos seus Dados, saber se estão a ser tratados e obter uma cópia dos mesmos.',
          'Verificar a exatidão dos seus Dados e solicitar a sua atualização ou retificação.',
          'Solicitar a limitação do tratamento dos seus Dados.',
          'Solicitar o apagamento dos seus Dados Pessoais.',
          'Receber os seus Dados em formato estruturado, de uso corrente e de leitura automática e, quando tecnicamente possível, transmiti-los a outro responsável pelo tratamento.',
          'Apresentar reclamação junto da autoridade de controlo competente.',
        ],
      },
      {
        heading: 'Direito de oposição',
        paragraphs: [
          'Quando os Dados Pessoais sejam tratados para efeitos dos interesses legítimos prosseguidos pelo Proprietário, o Utilizador pode opor-se a esse tratamento invocando uma razão relativa à sua situação específica.',
          'Se os seus Dados Pessoais forem tratados para finalidades de comercialização direta, o Utilizador pode opor-se a esse tratamento a qualquer momento, gratuitamente e sem necessidade de justificação. Exercida a oposição, os Dados deixarão de ser tratados para essa finalidade.',
        ],
      },
      {
        heading: 'Como exercer estes direitos',
        paragraphs: [
          `Qualquer pedido para exercer estes direitos pode ser dirigido ao Proprietário para ${PRIVACY_POLICY_OWNER_EMAIL}. Os pedidos são gratuitos e serão respondidos o mais rapidamente possível e sempre no prazo de um mês a contar da receção, prorrogável nos termos legais.`,
          'O Utilizador tem ainda o direito de apresentar reclamação junto da Comissão Nacional de Proteção de Dados, autoridade de controlo competente em Portugal, através de www.cnpd.pt.',
        ],
      },
    ],
  },
  {
    id: 'informacoes-adicionais',
    title: 'Informações adicionais sobre a recolha e tratamento de Dados',
    blocks: [
      {
        heading: 'Ações judiciais',
        paragraphs: [
          'Os Dados Pessoais do Utilizador podem ser utilizados para fins legais pelo Proprietário, em tribunal ou nas fases conducentes a uma eventual ação judicial decorrente da utilização indevida desta Aplicação ou de Serviços relacionados. O Utilizador declara ter conhecimento de que o Proprietário pode ser obrigado a revelar Dados Pessoais a pedido de autoridades públicas competentes.',
        ],
      },
      {
        heading: 'Relatórios do sistema e manutenção',
        paragraphs: [
          'Para efeitos de funcionamento e manutenção, esta Aplicação e os serviços de terceiros que utiliza podem recolher ficheiros que registam a interação com a Aplicação, bem como outros Dados Pessoais como o endereço IP.',
        ],
      },
      {
        heading: 'Informações não constantes da presente política',
        paragraphs: [
          'A qualquer momento pode ser solicitada ao Proprietário informação adicional sobre a recolha ou o tratamento de Dados Pessoais, através dos contactos indicados no início deste documento.',
        ],
      },
      {
        heading: 'Alterações à presente política de privacidade',
        paragraphs: [
          'O Proprietário reserva-se o direito de alterar a presente política de privacidade a qualquer momento, notificando os Utilizadores nesta página e, quando técnica e legalmente possível, através dos contactos disponíveis. Recomenda-se a consulta regular desta página, verificando a versão e a data de entrada em vigor indicadas.',
          'Caso as alterações afetem tratamentos realizados com base no consentimento do Utilizador, o Proprietário obterá novo consentimento quando necessário.',
        ],
      },
    ],
  },
  {
    id: 'definicoes',
    title: 'Definições e referências jurídicas',
    blocks: [
      {
        heading: 'Dados Pessoais (ou Dados)',
        paragraphs: [
          'Qualquer informação que, direta ou indiretamente, ou em articulação com outras informações, permita a identificação ou a identificabilidade de uma pessoa singular.',
        ],
      },
      {
        heading: 'Dados de Utilização',
        paragraphs: [
          'Informações recolhidas automaticamente através desta Aplicação, ou de serviços de terceiros nela utilizados, que podem incluir o endereço IP, os endereços URI dos recursos pedidos, a data e hora do pedido, o método utilizado, o tamanho da resposta, o código de estado devolvido pelo servidor, o país de origem, as características do navegador e do sistema operativo, e informação sobre a sequência de páginas visitadas.',
        ],
      },
      {
        heading: 'Utilizador',
        paragraphs: [
          'A pessoa que utiliza esta Aplicação, coincidindo, salvo indicação em contrário, com o Titular dos Dados.',
        ],
      },
      {
        heading: 'Titular dos Dados',
        paragraphs: ['A pessoa singular a quem os Dados Pessoais se referem.'],
      },
      {
        heading: 'Subcontratante',
        paragraphs: [
          'A pessoa singular ou coletiva, autoridade, agência ou outro organismo que trate Dados Pessoais por conta do Responsável pelo Tratamento.',
        ],
      },
      {
        heading: 'Responsável pelo Tratamento (ou Proprietário)',
        paragraphs: [
          'A pessoa singular ou coletiva, autoridade, agência ou outro organismo que, individualmente ou em conjunto com outros, determina as finalidades e os meios do tratamento de Dados Pessoais. Salvo disposição em contrário, o Responsável pelo Tratamento é o Proprietário desta Aplicação.',
        ],
      },
      {
        heading: 'Esta Aplicação',
        paragraphs: [
          'O site e a aplicação BelaHora, enquanto meios através dos quais os Dados Pessoais do Utilizador são recolhidos e tratados.',
        ],
      },
      {
        heading: 'União Europeia (ou UE)',
        paragraphs: [
          'Salvo indicação em contrário, todas as referências à União Europeia neste documento incluem os atuais Estados-Membros da União Europeia e do Espaço Económico Europeu.',
        ],
      },
      {
        heading: 'RGPD',
        paragraphs: ['O Regulamento (UE) 2016/679.'],
      },
      {
        paragraphs: [
          'A presente política respeita apenas a esta Aplicação, salvo indicação em contrário no presente documento.',
        ],
      },
    ],
  },
];
